import { MunchiLogo } from "@/components/layout/MunchiLogo";

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full border-t border-border/30 py-4 mt-4">
      <div className="px-4 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <span>Powered by</span>
          <MunchiLogo className="h-4 w-auto" />
        </div>
        <a
          href="https://www.gomunchi.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-sm text-muted-foreground hover:text-primary transition-colors"
        >
          © Munchi {year}
        </a>
      </div>
    </footer>
  );
}
